function validateMeetingTopic(topic) {
  return topic.length > process.env.REACT_APP_ZOOM_MEETING_TOPIC_MAX_LENGTH;
}

export default validateMeetingTopic;